import { render, staticRenderFns } from "./GolfSkillsAssessments.vue?vue&type=template&id=182eb80f&"
import script from "./GolfSkillsAssessments.vue?vue&type=script&lang=js&"
export * from "./GolfSkillsAssessments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports